import { jsx } from 'react/jsx-runtime';
import { useSensors, useSensor, DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, horizontalListSortingStrategy, arrayMove } from '@dnd-kit/sortable';
import { MouseSensor } from './specifications/sensor.mjs';

function DndKitGroup({
  children,
  items,
  onReorder,
  getIdentifier,
  dndContextProps,
  axis,
  sortingStrategy,
  disabled
}) {
  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 4
      }
    })
  );
  return /* @__PURE__ */ jsx(
    DndContext,
    {
      ...dndContextProps,
      sensors: dndContextProps?.sensors ?? sensors,
      collisionDetection: closestCenter,
      onDragEnd: (event) => {
        const { active, over } = event;
        if (active.id !== over?.id) {
          const oldIndex = items.findIndex(
            (template) => getIdentifier(template) === active.id
          );
          const newIndex = items.findIndex(
            (template) => getIdentifier(template) === over?.id
          );
          if (oldIndex > -1 && newIndex > -1) {
            onReorder(arrayMove(items, oldIndex, newIndex), oldIndex, newIndex);
          }
        }
        if (typeof dndContextProps?.onDragEnd === "function") {
          dndContextProps.onDragEnd(event);
        }
      },
      children: /* @__PURE__ */ jsx(
        SortableContext,
        {
          items: items.map(getIdentifier),
          disabled,
          strategy: sortingStrategy || (axis ? {
            x: horizontalListSortingStrategy,
            y: verticalListSortingStrategy
          }[axis] : void 0),
          children
        }
      )
    }
  );
}

export { DndKitGroup as default };
//# sourceMappingURL=Group.mjs.map
